import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import PressureIcon from '@/comp/common/icons/PressureIcon';
import { MetricType } from '@/constants/metric-type.enum';
import UnitsEnum from '@/constants/unitsEnum';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { PressureSensorNodeModel } from './PressureSensorNodeModel';
import SensorNodeWidget from '../../components/SensorNodeWidget/SensorNodeWidget';

export class PressureSensorNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.PressureSensor);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new PressureSensorNodeModel();
  }

  nodeUI(event) {
    return (
      <SensorNodeWidget
        engine={this.engine}
        node={event.model}
        width={50}
        height={44}
        data={[
          {
            metric: MetricType.PressureBar,
            unit: UnitsEnum.bar,
            Icon: <PressureIcon />,
          },
        ]}
      />
    );
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
